import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserService } from '../services/user-service/user.service';

export const authGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.isAuthenticated$.pipe(
    map((isAuthenticated) => (isAuthenticated ? true : router.createUrlTree(['/login'])))
  );
};
